import { ReactComponent as CheckIcon } from '../assets/checkIcon.svg'
import { ReactComponent as CloseIcon } from '../assets/closeIcon.svg'
import { ReactComponent as EditIcon } from '../assets/editIcon.svg'
import { ReactComponent as HistoryPaymentsIcon } from '../assets/historyPayments.svg'
import { ReactComponent as TrashIcon } from '../assets/deleteIcon.svg'
import FeatureButton from '@tcomponents/FeatureButton/FeatureButton'
import { COLLECTION_ADMINISTRATION_CODES } from '@constants/modules/collectionAdministration/collectionAdministrationCodes'

export const dropdownCollectionAdministrationItems = ({
    isDelete,
    status,
    record,
    onRestore,
    onEnableDisable,
    onDelete,
    handleRedirectTo
}) => {

    const deleteOptions = [
        {
            key: 0,
            label: <FeatureButton
                code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_DELETE_TEMPLATE}
                dropdownItem
                icon={<CheckIcon color="#4D4D4D" />}
                tooltip='Restaurar'
                popoverProps={{
                    style: { zIndex: 2000 }
                }}
                onClick={() => {
                    return onRestore({ charge_id: record.charge_id, isDeleted: false })
                }}
            >
                Restaurar
            </FeatureButton>,
            icon: undefined,
            action: () => {

            }
        },
    ]

    const defaultOptions = [
        {
            key: 0,
            label: <FeatureButton
                code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_ENABLE_DISABLE_TEMPLATE}
                dropdownItem
                icon={status === 'draft' || status === 'inactive' ? <CheckIcon color="#4D4D4D" /> : <CloseIcon color="#4D4D4D" />}
                tooltip={status === 'draft' || status === 'inactive' ? 'Activar' : 'Desactivar'}
                popoverProps={{
                    style: { zIndex: 2000 }
                }}
                onClick={() => {
                    if (status === 'deleted') return
                    return onEnableDisable({ charge_id: record.charge_id, isDeleted: false })
                }}
            >
                {status === 'draft' || status === 'inactive' ? 'Activar' : 'Desactivar'}
            </FeatureButton>,
            disabled: status === 'deleted',
            action: () => {

            }
        },
        {
            key: 1,
            label: <FeatureButton
                code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_UPDATE_TEMPLATE}
                dropdownItem
                icon={<EditIcon color="#4D4D4D" />}
                tooltip='Editar'
                popoverProps={{
                    style: { zIndex: 2000 }
                }}
                onClick={() => {
                    return handleRedirectTo(`/administration-collection/template/${record?.charge_id}`)
                }}
            >
                Editar
            </FeatureButton>,
            action: () => {
            }
        },
        {
            key: 2,
            label: <FeatureButton
                code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_PAYMENTS_HISTORY}
                dropdownItem
                icon={<HistoryPaymentsIcon style={{ minWidth: '24px' }} color="#4D4D4D" />}
                tooltip='Historial de pagos'
                popoverProps={{
                    style: { zIndex: 2000 }
                }}
                onClick={() => handleRedirectTo(`/administration-collection/history/${record?.charge_id}`, {
                    currentCharge: {
                        ...record
                    }
                })}
            >
                Historial de pagos
            </FeatureButton>,
        },
        {
            key: 3,
            label: <FeatureButton
                code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_DELETE_TEMPLATE}
                icon={<TrashIcon color="#4D4D4D" />}
                tooltip='Eliminar'
                popoverProps={{
                    style: { zIndex: 2000 }
                }}
                dropdownItem
                onClick={() => {
                    if (status === 'deleted') return
                    return onDelete({ charge_id: record.charge_id, isDeleted: true })
                }}
            >
                Eliminar
            </FeatureButton>,
            disabled: status === 'deleted',
            action: () => {

            }
        }
    ]


    return isDelete ? deleteOptions : defaultOptions
}